import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type BadgeProps = ComponentProps<typeof Badge>;

export const Badge = styled("span", {
  // Reset
  boxSizing: "border-box",
  display: "inline-block",

  // Custom
  lineHeight: 1,
  borderRadius: 9999,
  fontWeight: 600,
  fontSize: "$xs",
  padding: "$2 $3",

  variants: {
    variant: {
      primary: {
        color: "$primary-dark",
        backgroundColor: "$primary-light",
        fill: "$primary-dark",
      },
      success: {
        color: "$success-dark",
        backgroundColor: "$success-light",
        fill: "$success-dark",
      },
      warning: {
        color: "$warning-dark",
        backgroundColor: "$warning-light",
        fill: "$warning-dark",
      },
      danger: {
        color: "$error-base",
        backgroundColor: "$error-light",
        fill: "$error-base",
      },
      neutral: {
        color: "$neutrals-dark",
        backgroundColor: "$neutrals-lightest",
        border: "1px solid $colors$neutrals-light",
      },
      error: {
        color: "$neutrals-base",
        backgroundColor: "$error-light",
        border: "1px solid $colors$error-base",
      },
    },
    size: {
      sm: {
        fontSize: "$xxs",
        padding: "$1",
      },
      md: {
        fontSize: "$sm",
        padding: "$2",
      },
    },
    fw: {
      "400": {
        fw: 400,
      },
      "500": {
        fw: 500,
      },
      "600": {
        fw: 600,
      },
      "700": {
        fw: 700,
      },
    },
  },

  defaultVariants: {
    variant: "primary",
    size: "sm",
    fw: "700",
  },
});
